import * as customerActionCreators from 'store/actionCreators/customers';

import { customerSource } from 'sources';
import { setError } from 'store/actions/app';
import { fetchAddress } from 'store/actions/dataSources/addresses';
import { AppThunk } from 'store/store';
import { Customer } from 'types';

export const fetchCustomer = (id: string): AppThunk => async (
  dispatch: any // TODO: ThunkDispatch? Change in future story.
): Promise<Customer> => {
  try {
    const customer = await customerSource.Fetch(id);
    dispatch(customerActionCreators.fetchSuccess(customer));

    return customer;
  } catch (e) {
    dispatch(setError(e?.message));

    return Promise.reject(e);
  }
};

export const fetchCustomerWithAddress = (id: string): AppThunk => async (
  dispatch: any // TODO: ThunkDispatch? Change in future story.
): Promise<void> => {
  const customer = await dispatch(fetchCustomer(id));

  if (customer.addressId) {
    await dispatch(fetchAddress(customer.addressId));
  }
};
